<template>
    <b-modal
      ref="dtModalUsers"
      hide-footer
      centered
      size="lg"
      scrollable
      class="p-1"
      id="bv-modal-users"
    >
      <div class="modal-log" v-if="logInfo">
        <fieldset class="made-up avoid-page-break">
          <!-- (1) LEGEND exibe o nome do operador -->
          <legend>{{ logInfo.user }}</legend>
  
          <div class="row">
            <!-- COLUNA “Fila” (quando houver filas) -->
            <div class="col-md-6" v-if="hasFilas">
              <label for="queueChat"><strong>Fila</strong></label>
              <div
                class="form-control mb-2"
                v-for="(filaNome, idx) in logInfo.queueChat"
                :key="'fila-' + idx"
              >
                {{ filaNome }}
              </div>
            </div>
            <!-- COLUNA “Fila” (quando NÃO houver filas) -->
            <div class="col-md-6" v-else>
              <label for="queueChat"><strong>Fila</strong></label>
              <small class="text-muted">Nenhuma fila atribuída</small>
            </div>
  
            <!-- COLUNA “Status” (quando houver filas) -->
            <div class="col-md-6" v-if="hasFilas">
              <label for="status"><strong>Status</strong></label>
              <div
                class="form-control mb-2 d-flex align-items-center"
                v-for="(filaNome, idx) in logInfo.queueChat"
                :key="'status-' + idx"
              >
                <!-- Para cada fila, usamos getStatusCode(idx) -->
                <b-badge :variant="badgeVariant(getStatusCode(idx))">
                  {{ badgeText(getStatusCode(idx)) }}
                </b-badge>
              </div>
            </div>
            <!-- COLUNA “Status” (quando NÃO houver filas) -->
            <div class="col-md-6" v-else>
              <label for="status"><strong>Status</strong></label>
              <small class="text-muted">–</small>
            </div>
          </div>
        </fieldset>
      </div>
    </b-modal>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  
  export default {
    name: "ModalUsers",
    computed: {
      // Mapeia o getter que traz rawLogInfo do Vuex
      ...mapGetters({
        rawLogInfo: "getlogInfo"
      }),
  
      // Normaliza logInfo para sempre ter user, queueChat e opcoes.fila como array
      logInfo() {
        const info = this.rawLogInfo || {};
        return {
          user: info.user || "",
          queueChat: Array.isArray(info.queueChat) ? info.queueChat : [],
          opcoes: {
            fila:
              info.opcoes && Array.isArray(info.opcoes.fila)
                ? info.opcoes.fila
                : []
          }
        };
      },
  
      // true se houver pelo menos uma fila
      hasFilas() {
        return this.logInfo.queueChat.length > 0;
      }
    },
    methods: {
      openModal() {
        if (this.$refs.dtModalUsers) {
          this.$refs.dtModalUsers.show();
        } else {
          console.warn("ModalUsers.openModal(): $refs.dtModalUsers está undefined");
        }
      },
  
      // Retorna “c_deslogado” caso não haja um código em opcoes.fila[idx]
      getStatusCode(idx) {
        return this.logInfo.opcoes.fila[idx] || "c_deslogado";
      },
  
      // Transforma um código em texto
      badgeText(statusCode) {
        if (statusCode === "c_deslogado") return "Deslogado";
        if (statusCode === "b_ativo") return "Disponível";
        if (statusCode === "a_em_atendimento") return "Em Atendimento";
        return "Desconhecido";
      },
  
      // Transforma um código em variante de cor do badge
      badgeVariant(statusCode) {
        if (statusCode === "c_deslogado") return "danger";
        if (statusCode === "b_ativo") return "primary";
        if (statusCode === "a_em_atendimento") return "warning";
        return "secondary";
      }
    },
    mounted() {
      // Apenas para debug no console
      this.$nextTick(() => {
        console.log(">>> [modalUsers] logInfo recebido no modal:", this.logInfo);
        console.log("modalUsers mounted(): ref dtModalUsers →", this.$refs.dtModalUsers);
      });
    }
  };
  </script>
  
  <style scoped>
  .modal-log {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 80vh; /* limitando altura para rolagem */
  }
  
  /* Estilo geral do fieldset “made-up” */
  .made-up {
    font-family: Arial, sans-serif;
    margin: 10px;
    background: #fff;
    border: solid 1px #9797a6;
    border-radius: 2px;
    padding: 10px;
  }
  
  .made-up fieldset {
    margin: 5px 30px;
  }
  
  /* Estilo do título (legend) */
  .made-up legend {
    background: #1c869a;
    color: #fefefe;
    margin: 0px;
    padding: 5px 20px;
    font-size: 14px;
    border-radius: 2px;
  }
  
  /* Fonte de labels, inputs e textareas dentro do modal */
  .modal-log label,
  .modal-log input,
  .modal-log textarea {
    font-size: 12px;
  }
  
  /* Evitar quebra dentro do fieldset ao imprimir */
  .avoid-page-break {
    page-break-inside: avoid;
  }
  </style>
  